export const NEW_FILTER_NAME = 'New Filter';

export const NEW_FILTER = {
    name: NEW_FILTER_NAME,
    rules: [],
};

export const UNNAMED_FILTER = 'Unnamed Filter';

export const DUPLICATE_FILTER_NAME_ERROR = 'This filter name is already used';
